// extracted by mini-css-extract-plugin
export default {"container":"fileUploader_container__HPlbE","button":"fileUploader_button__XBjW8","title":"fileUploader_title__onmZ8"};